import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import config from 'config'

import styles from './styles.module.scss'

export default function PublicGroups() {
  const { t } = useTranslation()

  const { isNative } = useSelector((state) => state.common)
  const { profileData } = useSelector((state) => state.myProfile)

  return (
    <div className={`${styles.publicGroups}`}>
      {profileData.groups && (
        <h2 className={`${styles.pgTitle}`}>
          {profileData.editable === 0
            ? t('my_profile.public_groups.titleNormalUser', { username: profileData.user.first_name })
            : t('my_profile.public_groups.titleLoggedUser')}
        </h2>
      )}
      {profileData.groups && (
        <div className={`${styles.groupsWrap}`}>
          {profileData.groups.map((a, index) => (
            <React.Fragment>
              {isNative ? (
                <div onClick={() => (window.location = config.webUrl + `/0/home/group/${a.group_id}`)}>
                  <div key={index} className={`${styles.groupBox}`}>
                    <img src={`${a.group_cover_photo}`} alt={a.group_name} />
                    <h2>{a.group_name}</h2>
                  </div>
                </div>
              ) : (
                <Link to={`/0/home/group/${a.group_id}`}>
                  <div key={index} className={`${styles.groupBox}`}>
                    <img src={`${a.group_cover_photo}`} alt={a.group_name} />
                    <h2>{a.group_name}</h2>
                  </div>
                </Link>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  )
}
